import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Container, Box } from '@mui/material';
import ProductGrid from './components/ProductGrid';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0D6B4C',
    },
    background: {
      default: '#f8f8f8',
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#2C3E50',
    },
    h4: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#2C3E50',
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width: 1200px)': {
            maxWidth: '1200px',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f8f8' }}>
        <ProductGrid />
      </Box>
    </ThemeProvider>
  );
}

export default App;
